/**
 * @file new-order-span.tsx
 * @module app/modules/_common/components/new-order-span
 * @description Reusable component to display new order status icon with tooltip.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.3.0
 * @version 1.3.0
 */

import { OverlayTrigger, Popover } from 'react-bootstrap';
import { NewCustomerPriorityOrderMsg } from '../../../../utils/common.constants';
import statusCircleIcon from '../../../../_admin/assets/media/svg_uTrade/priority.svg';

interface NewCustomerPriorityOrderSpanProps {
  className?: string;
  isNewOrder?: number;
  placement?: 'top' | 'bottom' | 'left' | 'right';
}

export const NewCustomerPriorityOrderSpan: React.FC<
  NewCustomerPriorityOrderSpanProps
> = ({ className = 'ms-2', isNewOrder, placement = 'top' }) => {
  return (
    <>
      {isNewOrder ? (
        isNewOrder !== -1 && isNewOrder !== 0 ? (
          <span
            className={`${className} border border-light rounded p-2 release-highlighter--new-customer-priority-order`}
          >
            <OverlayTrigger
              trigger={['hover', 'focus']}
              placement={placement}
              overlay={
                <Popover className="bg-dark">
                  <Popover.Body className="text-white fw-500 py-2 px-3">
                    {NewCustomerPriorityOrderMsg +
                      '. Order number: ' +
                      isNewOrder}
                  </Popover.Body>
                </Popover>
              }
            >
              <img
                width={20}
                height={20}
                src={statusCircleIcon}
                alt="Status Info"
                className="cursor-pointer"
              />
            </OverlayTrigger>
          </span>
        ) : null
      ) : null}
    </>
  );
};

export default NewCustomerPriorityOrderSpan;
